<div class="menu-page">

  <app-error
    *ngIf="error"
    [title]="''"
  ></app-error>


  <!-- =====================================================
       PAGE HEADER
  ====================================================== -->

  <header class="menu-page__header">

    <div class="menu-page__heading">
      <span class="menu-page__eyebrow">
        MENU BUILDER
      </span>

      <h1>ციფრული მენიუ</h1>

      <p>
        მართე კატეგორიები, პროდუქტები, ფასები და ხელმისაწვდომობა.
      </p>
    </div>

    <button
      type="button"
      class="menu-page__primary-action"
      (click)="addNewProduct()"
    >
      <i class="fi fi-rr-plus"></i>
      <span>პროდუქტის დამატება</span>
    </button>

  </header>


  <!-- =====================================================
       MENU BUILDER
  ====================================================== -->

  <section class="menu-builder">

    <!-- ===================================================
         LEFT - CATEGORIES
    ==================================================== -->

    <aside class="menu-builder__categories">

      <app-app-category
        (reloadapps)="getCategories()"
      ></app-app-category>

    </aside>


    <!-- ===================================================
         RIGHT - PRODUCTS
    ==================================================== -->

    <div class="menu-builder__products">

      <header class="products-header">

        <div>
          <span class="products-header__eyebrow">
            PRODUCTS
          </span>

          <h2>პროდუქტები</h2>

          <p>
            {{ data?.length || 0 }} პროდუქტი მენიუში
          </p>
        </div>

      </header>


      <!-- =================================================
           LOADING
      ================================================== -->

      <div
        class="products-loading"
        *ngIf="load"
      >

        <div
          class="product-skeleton"
          *ngFor="let skeleton of [1, 2, 3]"
        >
          <div class="product-skeleton__image"></div>

          <div class="product-skeleton__content">
            <span></span>
            <small></small>
          </div>
        </div>

      </div>


      <!-- =================================================
           EMPTY STATE
      ================================================== -->

      <div
        class="products-empty"
        *ngIf="!load && (!data || data.length === 0)"
      >

        <div class="products-empty__icon">
          <i class="fi fi-rr-hamburger-soda"></i>
        </div>

        <h3>
          პროდუქტები ჯერ არ არის
        </h3>

        <p>
          დაამატე პირველი პროდუქტი შენს ციფრულ მენიუში.
        </p>

        <button
          type="button"
          (click)="addNewProduct()"
        >
          <i class="fi fi-rr-plus"></i>
          პროდუქტის დამატება
        </button>

      </div>


      <!-- =================================================
           PRODUCT LIST
      ================================================== -->

      <div
        class="products-list"
        *ngIf="!load && data?.length"
      >

        <article
          class="product-row"
          *ngFor="let item of data"
        >

          <!-- IMAGE -->

          <button
            type="button"
            class="product-row__image"
            (click)="editProduct(item)"
          >

            <img
              *ngIf="item?.image"
              [src]="
                'https://s3.eu-north-1.amazonaws.com/menuload.com'
                + item.image
              "
              [alt]="
                item?.product_name?.[systemLang]
                || 'Product'
              "
              loading="lazy"
            >

            <span
              *ngIf="!item?.image"
              class="product-row__image-placeholder"
            >
              <i class="fi fi-rr-hamburger-soda"></i>
            </span>

          </button>


          <!-- INFORMATION -->

          <button
            type="button"
            class="product-row__content"
            (click)="editProduct(item)"
          >

            <strong>
              {{
                item?.product_name?.[systemLang]
                || ('NO_TITLE' | translate)
              }}
            </strong>

            <small>
              {{
                item?.descriptions?.[systemLang]
                || 'აღწერა არ არის დამატებული'
              }}
            </small>

          </button>


          <!-- PRICE -->

          <div class="product-row__price">
            <small>ფასი</small>

            <strong>
              ₾{{ item?.price || '0.00' }}
            </strong>
          </div>


          <!-- STATUS -->

          <div class="product-row__status">

            <span
              class="product-status"
              [class.product-status--hidden]="!item.show"
            >
              <i></i>

              {{
                item.show
                  ? 'აქტიური'
                  : 'დამალული'
              }}
            </span>

          </div>


          <!-- VISIBILITY -->

          <button
            type="button"
            class="product-row__action"
            [class.is-disabled]="!item.show"
            title="Visibility"
            (click)="setShow(item)"
          >

            <span
              *ngIf="
                showLoad &&
                showLoadid == item.id
              "
              class="spinner-border spinner-border-sm"
            ></span>

            <i
              *ngIf="
                !showLoad ||
                showLoadid !== item.id
              "
              [class]="
                item.show
                  ? 'fi fi-rr-eye'
                  : 'fi fi-rr-eye-crossed'
              "
            ></i>

          </button>


          <!-- EDIT -->

          <button
            type="button"
            class="product-row__action"
            title="Edit"
            (click)="editProduct(item)"
          >
            <i class="fi fi-rr-pencil"></i>
          </button>


          <!-- DELETE -->

          <button
            type="button"
            class="product-row__action product-row__action--danger"
            title="Delete"
            (click)="deleteProduct(item.id)"
          >

            <span
              *ngIf="
                deleteLoad &&
                deleteLoadid == item.id
              "
              class="spinner-border spinner-border-sm"
            ></span>

            <i
              *ngIf="
                !deleteLoad ||
                deleteLoadid !== item.id
              "
              class="fi fi-rr-trash"
            ></i>

          </button>

        </article>

      </div>

    </div>

  </section>


  <!-- =====================================================
       ADD / EDIT PRODUCT MODAL
  ====================================================== -->

<ng-template #addProductModal let-modal>

  <div class="product-modal">

    <!-- HEADER -->
    <header class="product-modal__header">

      <div class="product-modal__title">
        <span>
          {{ isEdit ? 'EDIT PRODUCT' : 'NEW PRODUCT' }}
        </span>

        <h3>
          {{
            isEdit
              ? ('SAVE' | translate)
              : ('DISHES_TR.ADD_DISH' | translate)
          }}
        </h3>
      </div>

      <div class="product-modal__header-actions">

        <app-language-selector
          [appId]="id"
          (languageChanged)="addLanguageField()"
        ></app-language-selector>

        <button
          type="button"
          class="product-modal__close"
          aria-label="Close"
          (click)="modal.dismiss('Cross click')"
        >
          ×
        </button>

      </div>

    </header>


    <!-- BODY -->
    <div class="product-modal__body">

      <form [formGroup]="form">

        <!-- TRANSLATED FIELDS -->
        <div formArrayName="titles">

          <div
            *ngFor="let item of titles.controls; let i = index"
            [formGroupName]="i"
          >

            <ng-container
              *ngIf="item.get('language')?.value === selectedLanguage"
            >

              <!-- NAME -->
              <div class="product-field">

                <label>
                  {{ 'DISHES_TR.TITLE_DISH' | translate }}
                </label>

                <div class="product-input">
                  <i class="fi fi-rr-text"></i>

                  <input
                    type="text"
                    formControlName="value"
                    [placeholder]="'DISHES_TR.TITLE_DISH' | translate"
                  >
                </div>

              </div>


              <!-- DESCRIPTION -->
              <div class="product-field">

                <label>
                  {{ 'DISHES_TR.DESCRIPTION_DISH' | translate }}
                </label>

                <div class="product-textarea">
                  <textarea
                    formControlName="description"
                    rows="3"
                    [placeholder]="'DISHES_TR.DESCRIPTION_DISH' | translate"
                  ></textarea>
                </div>

              </div>


              <!-- INGREDIENTS -->
              <div
                class="product-ingredients"
                formArrayName="ingredients"
              >

                <div class="product-ingredients__header">

                  <div>
                    <span>OPTIONS</span>

                    <h4>
                      {{ 'DISHES_TR.ADD_IGREDIENTS' | translate }}
                    </h4>
                  </div>

                  <button
                    type="button"
                    class="product-ingredients__add"
                    (click)="addIngredient(i)"
                  >
                    <i class="fi fi-rr-plus"></i>
                    დამატება
                  </button>

                </div>


                <div
                  class="ingredient-row"
                  *ngFor="
                    let ingredient of getIngredients(item).controls;
                    let j = index
                  "
                  [formGroupName]="j"
                >

                  <label class="ingredient-check">
                    <input
                      type="checkbox"
                      formControlName="check"
                    >

                    <span></span>
                  </label>


                  <div class="ingredient-field ingredient-field--name">

                    <input
                      type="text"
                      formControlName="name"
                      [placeholder]="'DISHES_TR.ADD_IGREDIENTS' | translate"
                    >

                  </div>


                  <div class="ingredient-field ingredient-field--price">

                    <input
                      type="text"
                      formControlName="ig_price"
                      [placeholder]="'DISHES_TR.PRICE' | translate"
                    >

                  </div>


                  <label class="ingredient-switch">

                    <input
                      type="checkbox"
                      formControlName="type"
                    >

                    <span></span>

                  </label>


                  <button
                    type="button"
                    class="ingredient-delete"
                    (click)="removeIngredient(i, j)"
                  >
                    <i class="fi fi-rr-trash"></i>
                  </button>

                </div>

              </div>

            </ng-container>

          </div>

        </div>


        <!-- CATEGORY -->
        <div class="product-field">

          <label for="cat">
            {{ 'CATEGORY.SELECT_CATEGORY' | translate }}
          </label>

          <div class="product-select">

            <i class="fi fi-rr-apps"></i>

            <select
              id="cat"
              formControlName="cat_id"
            >

              <option
                *ngFor="let category of categories"
                [value]="category.id"
              >
                {{
                  category?.titles?.[selectedLanguage]
                  || category?.titles?.[systemLang]
                  || 'Category'
                }}
              </option>

            </select>

          </div>

        </div>


        <!-- PRICE + SALE -->
        <div class="product-fields-row">

          <div class="product-field">

            <label>
              {{ 'DISHES_TR.PRICE' | translate }}
            </label>

            <div class="product-input">

              <span class="product-input__currency">
                ₾
              </span>

              <input
                type="text"
                formControlName="price"
                placeholder="0.00"
              >

            </div>

          </div>


          <div class="product-field">

            <label>
              {{ 'DISHES_TR.SALE' | translate }}
            </label>

            <div class="product-input">

              <i class="fi fi-rr-badge-percent"></i>

              <input
                type="text"
                formControlName="sale"
                placeholder="0.00"
              >

            </div>

          </div>

        </div>


        <!-- IMAGE -->
        <div class="product-upload">

          <div class="product-upload__heading">
            <span>IMAGE</span>

            <h4>პროდუქტის ფოტო</h4>

            <p>
              ატვირთე პროდუქტის ხარისხიანი ფოტო.
            </p>
          </div>

          <app-app-upload-img
            [appId]="id"
            [productId]="form.get('id')?.value"
            [imgUrl]="form.get('image')?.value"
            (productIdGenerated)="onProductIdGenerated($event)"
          ></app-app-upload-img>

        </div>


        <!-- VISIBILITY -->
        <div class="product-visibility">

          <div>

            <span class="product-visibility__icon">
              <i
                [class]="
                  form.get('show')?.value
                    ? 'fi fi-rr-eye'
                    : 'fi fi-rr-eye-crossed'
                "
              ></i>
            </span>

            <div>
              <strong>
                პროდუქტის ჩვენება
              </strong>

              <small>
                {{
                  form.get('show')?.value
                    ? 'პროდუქტი ჩანს მომხმარებლის მენიუში'
                    : 'პროდუქტი დამალულია მომხმარებლისგან'
                }}
              </small>
            </div>

          </div>


          <button
            type="button"
            class="product-visibility__button"
            [class.is-active]="form.get('show')?.value"
            (click)="setShow(form.value)"
          >

            <span
              *ngIf="showLoad"
              class="spinner-border spinner-border-sm"
            ></span>

            <span *ngIf="!showLoad">
              {{
                form.get('show')?.value
                  ? 'აქტიური'
                  : 'დამალული'
              }}
            </span>

          </button>

        </div>

      </form>

    </div>


    <!-- FOOTER -->
    <footer class="product-modal__footer">

      <button
        type="button"
        class="product-modal__cancel"
        (click)="modal.dismiss('cancel')"
      >
        გაუქმება
      </button>

      <button
        type="button"
        class="product-modal__save"
        [disabled]="isProductLoad"
        (click)="createOrUpdate()"
      >

        <span
          *ngIf="isProductLoad"
          class="spinner-border spinner-border-sm"
        ></span>

        <span>
          {{
            isEdit
              ? ('SAVE' | translate)
              : ('DISHES_TR.ADD_DISH' | translate)
          }}
        </span>

        <i
          *ngIf="!isProductLoad"
          class="fi fi-rr-arrow-small-right"
        ></i>

      </button>

    </footer>

  </div>

</ng-template>

</div>